import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {  message } from 'antd';

const ProtectedRoute = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            message.error('Deve iniciar sessão');
            navigate('/');
        }
    }, [user, navigate]);

    return user ? children : null; // Renderiza os filhos apenas se o usuário estiver autenticado
};

export default ProtectedRoute;
